import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { GenesysCloudService } from 'src/app/services/genesys-cloud.service';


@Component({
  selector: 'app-alis-sso',
  templateUrl: './alis-sso.component.html',
  styleUrls: ['./alis-sso.component.scss']
})
export class ALISSSOComponent implements OnInit, OnDestroy {
  
//CCR3-13543 - ALIS SSO Integration
 private initSub!: Subscription;
  constructor(public ALISservice:GenesysCloudService) { }

  
  ngOnInit(): void {
    /*istanbul ignore next*/
    this.initSub = this.ALISservice.initialize()?.subscribe({
      next: () => this.ALISservice.sendMessage(true),
      error: () => this.ALISservice.sendMessage(false),
    });
  }

  ngOnDestroy(): void {
    this.initSub?.unsubscribe();
  }

}
